var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_3626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.28017 0 0 6.28017 0 14C0 21.7198 6.28017 28 14 28C21.7198 28 28 21.7198 28 14C28 6.28017 21.7198 0 14 0ZM21.2333 12.264L16.0697 17.3332C15.1562 18.2292 13.9802 18.676 12.803 18.676C11.6387 18.676 10.4743 18.2373 9.56433 17.3588L7.34883 15.1807C6.88917 14.7292 6.88333 13.9907 7.33483 13.531C7.78517 13.0702 8.526 13.0643 8.9845 13.517L11.193 15.6882C12.0983 16.5632 13.5275 16.5585 14.4375 15.6672L19.6 10.5992C20.0585 10.1465 20.7947 10.1547 21.2497 10.6143C21.7012 11.074 21.6942 11.8125 21.2333 12.264Z",
    fill: "#428D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_3626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectAnswer);
export default __webpack_public_path__ + "static/media/correctAnswer.057fce4da17f29d82f0a0ef90e2a397e.svg";
export { ForwardRef as ReactComponent };